module.exports = __webpack_public_path__ + "img/電気回路_1_10_4.ec62e8e3.png";